// extracted by mini-css-extract-plugin
module.exports = {"swiperAlt":"swiper-alt_swiperAlt__PpgHU"};